/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SkuProductUpdateReqVo
 */
export interface SkuProductUpdateReqVo {
    /**
     * SKU_PRODUCT ID
     * @type {number}
     * @memberof SkuProductUpdateReqVo
     */
    id: number;
    /**
     * 商品URL
     * @type {string}
     * @memberof SkuProductUpdateReqVo
     */
    productUrl?: string;
    /**
     * 商品图片URL
     * @type {string}
     * @memberof SkuProductUpdateReqVo
     */
    imageUrl?: string;
    /**
     * 颜色
     * @type {string}
     * @memberof SkuProductUpdateReqVo
     */
    color?: string;
    /**
     * 尺寸
     * @type {string}
     * @memberof SkuProductUpdateReqVo
     */
    size?: string;
    /**
     * 单价
     * @type {number}
     * @memberof SkuProductUpdateReqVo
     */
    unitPrice?: number;
    /**
     * 构成数量
     * @type {number}
     * @memberof SkuProductUpdateReqVo
     */
    productNumber?: number;
    /**
     * 通关类目ID
     * @type {number}
     * @memberof SkuProductUpdateReqVo
     */
    ctmsItemId?: number;
    /**
     * 海关商品英文名
     * @type {string}
     * @memberof SkuProductUpdateReqVo
     */
    coProNmEn?: string;
    /**
     * 海关编码
     * @type {string}
     * @memberof SkuProductUpdateReqVo
     */
    coHsCode?: string;
}

/**
 * Check if a given object implements the SkuProductUpdateReqVo interface.
 */
export function instanceOfSkuProductUpdateReqVo(value: object): value is SkuProductUpdateReqVo {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function SkuProductUpdateReqVoFromJSON(json: any): SkuProductUpdateReqVo {
    return SkuProductUpdateReqVoFromJSONTyped(json, false);
}

export function SkuProductUpdateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkuProductUpdateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'productUrl': json['productUrl'] == null ? undefined : json['productUrl'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'productNumber': json['productNumber'] == null ? undefined : json['productNumber'],
        'ctmsItemId': json['ctmsItemId'] == null ? undefined : json['ctmsItemId'],
        'coProNmEn': json['coProNmEn'] == null ? undefined : json['coProNmEn'],
        'coHsCode': json['coHsCode'] == null ? undefined : json['coHsCode'],
    };
}

export function SkuProductUpdateReqVoToJSON(json: any): SkuProductUpdateReqVo {
    return SkuProductUpdateReqVoToJSONTyped(json, false);
}

export function SkuProductUpdateReqVoToJSONTyped(value?: SkuProductUpdateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'productUrl': value['productUrl'],
        'imageUrl': value['imageUrl'],
        'color': value['color'],
        'size': value['size'],
        'unitPrice': value['unitPrice'],
        'productNumber': value['productNumber'],
        'ctmsItemId': value['ctmsItemId'],
        'coProNmEn': value['coProNmEn'],
        'coHsCode': value['coHsCode'],
    };
}

